export const CALENDAR_EVENTS = '/api/v1/calendar-events';
export const CALENDAR_EVENT = (calendarEventId: string) =>
    `/api/v1/calendar-events/${calendarEventId}`;
export const CALENDAR_EVENTS_MONTHLY = '/api/v1/calendar-events/monthly';
export const CALENDAR_EVENTS_DAILY = '/api/v1/calendar-events/daily';
